"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameplayFactory = void 0;
const react_1 = __importDefault(require("react"));
const types_1 = require("../types");
const gameplays_1 = require("../gameplays");
class GameplayFactory {
    constructor(card) {
        this.card = card;
    }
    selectGameplay(props) {
        if (props.card.cardQuestion.audioChoices.length > 0 &&
            props.card.gameplayInfo.choiceCount !== 0 &&
            props.card.cardQuestion.audioChoices.length >
                props.card.gameplayInfo.choiceCount) {
            props.card.cardQuestion.audioChoices =
                props.card.cardQuestion.audioChoices.slice(0, props.card.gameplayInfo.choiceCount);
        }
        if (props.card.cardQuestion.imageChoices.length > 0 &&
            props.card.gameplayInfo.choiceCount !== 0 &&
            props.card.cardQuestion.imageChoices.length >
                props.card.gameplayInfo.choiceCount) {
            props.card.cardQuestion.imageChoices =
                props.card.cardQuestion.imageChoices.slice(0, props.card.gameplayInfo.choiceCount);
        }
        if (props.card.cardQuestion.textChoices.length > 0 &&
            props.card.gameplayInfo.choiceCount !== 0 &&
            props.card.cardQuestion.textChoices.length >
                props.card.gameplayInfo.choiceCount) {
            props.card.cardQuestion.textChoices =
                props.card.cardQuestion.textChoices.slice(0, props.card.gameplayInfo.choiceCount);
        }
        if (props.gameplayStyle === types_1.GameplayStyle.PopQuizHost) {
            // need to return host view gameplay container
            switch (this.card.gameplayInfo.name) {
                case types_1.Gameplay.AudioWithChoicesGameplay001:
                case types_1.Gameplay.AudioWithChoicesGameplay002:
                case types_1.Gameplay.ComposeTheBlankWithLanguageNumberChoicesGameplay001:
                case types_1.Gameplay.FourImageChoicesGameplay003:
                case types_1.Gameplay.FourTextChoicesGameplay003:
                case types_1.Gameplay.FourTextChoicesGameplay004:
                    return react_1.default.createElement(gameplays_1.HostAudioGameplay, { props: props });
                case types_1.Gameplay.DiagramGameplay001:
                case types_1.Gameplay.DiagramGameplay002:
                case types_1.Gameplay.FillTheBlankWithMultipleChoiceSelectionGameplay001:
                case types_1.Gameplay.FourImageChoicesGameplay002:
                case types_1.Gameplay.ImageWithChoicesGameplay006:
                case types_1.Gameplay.MultipleChoiceSelectionGameplay001:
                case types_1.Gameplay.TextWithChoicesGameplay001:
                case types_1.Gameplay.TextWithChoicesGameplay002:
                case types_1.Gameplay.TextWithChoicesGameplay003:
                    return react_1.default.createElement(gameplays_1.HostTextGameplay, { props: props });
                case types_1.Gameplay.ImageWithChoicesGameplay001:
                case types_1.Gameplay.ImageWithChoicesGameplay002:
                case types_1.Gameplay.ImageWithChoicesGameplay003:
                    return react_1.default.createElement(gameplays_1.HostImageGameplay, { props: props });
                default:
                    break;
            }
            return react_1.default.createElement(gameplays_1.HostViewGameplayContainer, { props: props });
        }
        switch (this.card.gameplayInfo.name) {
            case types_1.Gameplay.TextWithChoicesGameplay001:
                return react_1.default.createElement(gameplays_1.TextWithChoicesGameplay001, { props: props });
            case types_1.Gameplay.TextWithChoicesGameplay002:
                return react_1.default.createElement(gameplays_1.TextWithChoicesGameplay002, { props: props });
            case types_1.Gameplay.TextWithChoicesGameplay003:
                return react_1.default.createElement(gameplays_1.TextWithChoicesGameplay003, { props: props });
            case types_1.Gameplay.AudioWithChoicesGameplay001:
                return react_1.default.createElement(gameplays_1.AudioWithChoicesGameplay001, { props: props });
            case types_1.Gameplay.AudioWithChoicesGameplay002:
                return react_1.default.createElement(gameplays_1.AudioWithChoicesGameplay002, { props: props });
            case types_1.Gameplay.ImageWithChoicesGameplay001:
                return react_1.default.createElement(gameplays_1.ImageWithChoicesGameplay001, { props: props });
            case types_1.Gameplay.ImageWithChoicesGameplay003:
                return react_1.default.createElement(gameplays_1.ImageWithChoicesGameplay003, { props: props });
            case types_1.Gameplay.ImageWithChoicesGameplay002:
            case types_1.Gameplay.ImageWithChoicesGameplay006:
                return react_1.default.createElement(gameplays_1.ImageWithChoicesGameplay002, { props: props });
            case types_1.Gameplay.FourImageChoicesGameplay002:
                return react_1.default.createElement(gameplays_1.FourImageChoicesGameplay002, { props: props });
            case types_1.Gameplay.FourImageChoicesGameplay003:
            case types_1.Gameplay.FourImageChoicesGameplay004:
                return react_1.default.createElement(gameplays_1.FourImageChoicesGameplay003, { props: props });
            case types_1.Gameplay.FourTextChoicesGameplay002:
                return react_1.default.createElement(gameplays_1.FourTextChoicesGameplay002, { props: props });
            case types_1.Gameplay.FourTextChoicesGameplay003:
            case types_1.Gameplay.FourTextChoicesGameplay004:
                return react_1.default.createElement(gameplays_1.FourTextChoicesGameplay003, { props: props });
            case types_1.Gameplay.DiagramGameplay001:
            case types_1.Gameplay.DiagramGameplay002:
                return react_1.default.createElement(gameplays_1.DiagramGameplayContainer2, { props: props });
            case types_1.Gameplay.ComposeTheBlankWithLanguageNumberChoicesGameplay001:
                return (react_1.default.createElement(gameplays_1.ComposeTheBlankWithLanguageNumberChoicesGameplay001, { props: props }));
            case types_1.Gameplay.FillTheBlankWithMultipleChoiceSelectionGameplay001:
                return (react_1.default.createElement(gameplays_1.FillTheBlankWithMultipleChoiceSelectionGameplay001, { props: props }));
            case types_1.Gameplay.MultipleChoiceSelectionGameplay001: {
                // need to manually add question bottom
                if (!props.card.cardQuestion.questionBottom) {
                    const questionBottom = props.card.cardAnswer.answerTexts
                        .map(() => '{}')
                        .join(' ');
                    props.card.cardQuestion.questionBottom = questionBottom;
                }
                if (!props.card.cardQuestion.translation) {
                    props.card.cardQuestion.translation =
                        props.card.cardQuestion.questionText;
                }
                return (react_1.default.createElement(gameplays_1.FillTheBlankWithMultipleChoiceSelectionGameplay001, { props: props }));
            }
            default:
                break;
        }
        return undefined;
    }
}
exports.GameplayFactory = GameplayFactory;
